// extracted by mini-css-extract-plugin
export default {"highlight":"rOoFCAjlp22pXUoPLNIz"};